import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  DiscountRequestNotification,
  DiscountRequestNotificationCounts,
} from 'interfaces';
import { NotificationsStoreType } from './notifications.types';

const initialState: NotificationsStoreType = {
  notificationList: null,
  newNotificationCounts: null,
  unreadNotificationCounts: null,
};

export const serviceNotificationsReducer = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setNotificationList: (
      state,
      action: PayloadAction<DiscountRequestNotification[] | null>,
    ) => {
      state.notificationList = action.payload;
    },
    setNewNotificationCounts: (
      state,
      action: PayloadAction<DiscountRequestNotificationCounts | null>,
    ) => {
      state.newNotificationCounts = action.payload;
    },
    setUnreadNotificationCounts: (
      state,
      action: PayloadAction<number | null>,
    ) => {
      state.unreadNotificationCounts = action.payload;
    },
  },
});

export const {
  setNotificationList,
  setNewNotificationCounts,
  setUnreadNotificationCounts,
} = serviceNotificationsReducer.actions;

export default serviceNotificationsReducer.reducer;
